import { createContext, useState } from 'react';

interface IFabricContext {
  canvas?: fabric.Canvas;
  activeObject?: fabric.Object;
  setCanvas?(initCanvas: fabric.Canvas): void;
  initCanvas:(newCanvas?: fabric.Canvas) => void;
  setActiveObject:(object: fabric.Object) => void;
  setCanvasToUndefined(): void;
}

const FabricContext = createContext({} as IFabricContext);

const FabricContextProvider = (props: {children: JSX.Element}): JSX.Element => {
  const [activeObject, setActiveObject] = useState<fabric.Object>();
  const [canvas, setCanvas] = useState<fabric.Canvas>();

  const initCanvas = (newCanvas?: fabric.Canvas): void => { 
    setCanvas(newCanvas);
  }

  const setCanvasToUndefined = () => {
    setCanvas(undefined);
  }

  const providerValue = {
    canvas,
    activeObject,
    initCanvas,
    setActiveObject,
    setCanvasToUndefined
  }

  return (
    <FabricContext.Provider value={providerValue}>
      {props.children}
    </FabricContext.Provider>
  );
}

export { FabricContext, FabricContextProvider};